<script setup lang="ts">
import { RouterView } from 'vue-router'
import { ref, onMounted } from 'vue'

const showAppBar = ref(false)

onMounted(() => {
  setTimeout(() => (showAppBar.value = true), 100)
})
</script>

<template>
  <v-app class="app-body text-dark">
    <v-main class="pb-2 overflow-hidden">
      <RouterView class="overflow-hidden" />
    </v-main>
  </v-app>
</template>

<style scoped>
.app-body {
  background-color: #eceff1;
}

.text-dark {
  color: #112e34;
}
</style>
